import * as React from 'react'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import questionCategories from 'modules/surveys/store/collections/questionCategories'

export function useQuestionCategory(questionCategoryId: string, formId: string) {
  const [questionCategory, setQuestionCategory] = React.useState(
    questionCategories.find({
      id: questionCategoryId,
    })
  )

  const { loading } = useUnsafeAsyncData(async () => {
    if (questionCategory) return

    await questionCategories.fetch({
      data: {
        surveys_form_id: formId,
      },
    })

    const _questionCategory = questionCategories.find({
      id: questionCategoryId,
    })

    setQuestionCategory(_questionCategory)
  }, [questionCategory])

  return {
    loading,
    questionCategory,
  }
}
